import React, { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import PageTitle from '../../../components/partials/PageTitle'
import { getAllClauses, resetSingleClause } from '../../../redux/slice/clauses/clauseSlice';
import pdf from "../../../assets/images/img-icons/pdf.png";
import excel from "../../../assets/images/img-icons/excel.png";
import { BeatLoader } from "react-spinners";
import { useReactToPrint } from 'react-to-print';
import PaginationLinks from '../../../components/pagination/PaginationLinks';
import moment from 'moment';
import striptags from 'striptags';

const SavingsPreloadedClause = () => {
    const [pageNumber, setPageNumber] = useState(1)
    const [searchBy, setSearchBy] = useState('');
    const [currentClauses, setCurrentClauses] = useState(null)
    const [hasAddClause, setHasAddClause] = useState()
    const [hasViewClause, setHasViewClause] = useState()
    const { all_savings_clauses } = useSelector((state) => state.clause);
    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const PCPdfRef = useRef();

    const navigate = useNavigate();
    const dispatch = useDispatch()

    // print table to pdf
    const generatePDF = useReactToPrint({
        content: () => PCPdfRef.current,
        documentTitle: "corperate customers",
    });

      // export data to excel file
    // const exportXlsxData = () => {
    //     const itemsWithValues = {};
    //     return all_savings_clauses?.data?.map((item) => {
    //     for (const key in item) {
    //         if (item[key]) {
    //         let keyChange = key?.split("_")?.join(" ");
    //         itemsWithValues[keyChange] = item[key];
    //         }
    //     }
    //     return itemsWithValues;
    //     });
    // };
    const breadcrumb = {
        from: {
          title: "settings",
          link: "/admin/settings",
        },
        current: {
          title: "preloaded clauses",
          link: null,
        },
    }

    const handleSearchBy = (e) => {
        e.preventDefault();
        if (searchBy?.length) {
          const payload = {
            search: searchBy,
            pageNumber: 1
          };
          dispatch(getAllClauses(payload));
        }
    };

    const fetchAllClausesHandler = async (pageNumber) => {
        if (!searchBy) {
            dispatch(getAllClauses({pageNumber, search: ''}))
        }
        dispatch(getAllClauses({pageNumber, search: searchBy}));
    };

    useEffect(() => {
        if (!searchBy) {
            dispatch(getAllClauses({pageNumber, search: ''}))
        }
      dispatch(resetSingleClause())
    }, [dispatch, pageNumber, searchBy])

    useEffect(() => {
      if (all_savings_clauses) {
        setCurrentClauses(all_savings_clauses?.data)
      }
    }, [all_savings_clauses])
    
    useEffect(() => {
        if (!user_permissions?.some(permission => permission.name === 'settings module') || !user_permissions?.some(permission => permission.name === 'clause module')) {
          navigate('/admin/dashboard')
        }

        setHasAddClause(user_permissions?.some(permission => permission.name === 'add clause'))
        setHasViewClause(user_permissions?.some(permission => permission.name === 'view clause details'))

    }, [navigate, user_permissions])
    
  return (
    <>
      {/* page title */}
      <PageTitle title='Savings Preloaded Clauses' breadcrumb={breadcrumb} />
      {/* end page title */}

        {!all_savings_clauses?.data && (
            <BeatLoader
                height='80'
                width='80'
                radius='9'
                color='#2e3192'
                ariaLabel='three-dots-loading'
                wrapperStyle={{}}
                wrapperClassName=''
                visible={true}
            />
        )}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
                <div className={`d-flex ${hasAddClause ? 'justify-content-between' : 'justify-content-end'}  mb-3`}>
                    {hasAddClause && <Link
                        className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p px-3'
                        style={{ height: "30px", padding: "10px 10px" }}
                        to='/admin/settings/preloaded-clauses/add-clause'
                    >
                        <span>
                            <i className='mdi mdi-plus fs-4'></i>
                        </span>
                        <span 
                            href='#' 
                            className='text-dark pe-2 text-white'
                        >
                            Add Clause
                        </span>
                    </Link>}
                    <div></div>
                </div>
                <div className='d-flex justify-content-end py-2'>
                    <div className='d-flex justify-content-between align-items-center gap-3'>
                        <form
                        onSubmit={handleSearchBy}
                        className='d-flex bg-primary-1 align-items-center '
                        style={{ height: "30px", width: "217px" }}
                        // ref={searchCorp}
                        >
                        <input
                            type='search'
                            value={searchBy}
                            className='border-0'
                            placeholder='Search...'
                            onChange={(e) => setSearchBy(e.target.value)}
                            style={{
                            height: "28px",
                            marginLeft: "1px",
                            outline: "none",
                            }}
                        />
                        <button
                            type='submit'
                            className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                            style={{ height: "28px" }}
                        >
                            <i className='uil uil-search text-white fs-4'></i>
                        </button>
                        </form>
                        <div className=' d-flex align-items-center border '>
                        <span
                            className='bg-info me-2 text-white'
                            style={{ padding: "3px" }}
                        >
                            Export to
                        </span>

                        <span
                            href='#'
                            id='btnExport'
                            className='me-1 cursor-p'
                            title='Export to Pdf'
                            onClick={generatePDF}
                        >
                            <img
                            src={pdf}
                            alt='export-pdf'
                            style={{ height: "20px" }}
                            />
                        </span>
                        {/* {all_savings_clauses ? (
                            <CSVLink
                            // data={exportXlsxData()}
                            style={{ fontWeight: "bolder", cursor: "pointer" }}
                            filename='Corperate customers'
                            >
                            <span
                                href='#'
                                id='btnExport'
                                className='mr-1'
                                title='Export to Excel'
                            >
                                <img
                                src={excel}
                                alt='export-excel'
                                style={{ height: "20px", marginRight: "5px" }}
                                />
                            </span>
                            </CSVLink>
                        ) : null} */}
                        </div>
                    </div>
                </div>
                <div className='col-12'>
                {currentClauses?.length < 1 ? (
                  <h5 className='alert alert-info'>Result not found!</h5>
                ) : (
                    <div className='position-relative'>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <div className='table-responsive'>
                                    <table
                                        className='table table-centered table-striped nowrap w-100 no-footer'
                                        ref={PCPdfRef}
                                    >
                                        <thead>
                                        <tr>
                                            <th
                                            className='sorting'
                                            tabIndex='0'
                                            rowSpan='1'
                                            colSpan='1'
                                            style={{ width: "130.8px" }}
                                            aria-label='Customer: activate to sort column ascending'
                                            >
                                            Name
                                            </th>
                                            <th
                                            className='sorting'
                                            tabIndex='0'
                                            rowSpan='1'
                                            colSpan='1'
                                            style={{ width: "120.8px" }}
                                            aria-label='Customer: activate to sort column ascending'
                                            >
                                            Policy Target
                                            </th>
                                            <th
                                            className='sorting'
                                            tabIndex='0'
                                            rowSpan='1'
                                            colSpan='1'
                                            style={{ width: "225.8px" }}
                                            >
                                            Description
                                            </th>
                                            <th
                                            className='sorting'
                                            tabIndex='0'
                                            rowSpan='1'
                                            colSpan='1'
                                            style={{ width: "137.8px" }}
                                            // aria-label='Email: activate to sort column ascending'
                                            >
                                            Date Created
                                            </th>
                                            {hasViewClause && <th
                                            tabIndex='0'
                                            rowSpan='1'
                                            colSpan='1'
                                            style={{ width: "100.8px" }}
                                            >Action</th>}
                                        </tr>
                                        </thead>
                                        {/* {console.log(currentClauses)} */}
                                        {currentClauses?.length ? (
                                        <tbody>
                                            {currentClauses?.map((item, i) => {
                                                const plainTextContent = striptags(item?.description);
                                            return(
                                            <tr key={i}>
                                                {/* {console.log(item)} */}
                                                <td>{item?.clause_name}</td>
                                                <td className='table-user'> {item?.policy_name}</td>
                                                <td className='text-dark'> {plainTextContent.substring(0,30)}....</td>
                                                <td> {moment(item?.created_at).format("D/M/Y")} </td>

                                                {hasViewClause && <td className='text-body'>
                                                <Link
                                                    to={`/admin/settings/preloaded-clauses/${item?.id}`}
                                                    state={{ id: item?.id, category: '2' }}
                                                >
                                                    <i className='mdi mdi-eye text-primary fs-4 mx-2'></i>
                                                </Link>
                                                </td>}
                                            </tr>
                                            )})}
                                        </tbody>
                                        ) : null}
                                    </table>
                                </div>
                                {all_savings_clauses?.data?.length < 1 ? (
                                <h5 className='alert alert-info'>No result found!</h5>
                                ) : null}
                                <div className='row mt-2'>
                                    <div className='col-sm-12 col-md-6'>
                                        <div
                                        className='dataTables_info table-pages'
                                        id='products-datatable_info'
                                        role='status'
                                        aria-live='polite'
                                        >
                                        Showing offices {all_savings_clauses.from} to{" "}
                                        {all_savings_clauses.to} of{" "}
                                        {all_savings_clauses.total}
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-6'>
                                        <PaginationLinks
                                            paginationData={all_savings_clauses}
                                            getNextPage={fetchAllClausesHandler}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {(isFiltering || isSearching) && (
                        <div
                            className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                            style={{ height: "100%" }}
                        >
                            <div className='mx-auto'>
                            <BounceLoader
                                color='#090b8f'
                                loading={true}
                                // cssOverride={override}
                                size={50}
                                aria-label='Loading Spinner'
                                data-testid='loader'
                                className='ms-3'
                            />
                            <span className='fw-bolder text-primary-1 ms-2'>
                                Please wait...
                            </span>
                            </div>
                        </div>
                        )} */}
                    </div>
                )}
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SavingsPreloadedClause